import { PillStyled } from "./PillStyled";

interface PillProps {
  text: string;
  color: string;
}

export const Pill = ({ text, color }: PillProps) => {
  return (
    <PillStyled data-testid="pill-container" style={{ backgroundColor: color }}>
    	<div className='overline1'>{text}</div>
    </PillStyled>
  );
};
